import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

type SourceRow = {
  id: string;
  external_reference: string | null;
  project_name: string | null;
  title: string;
  file_name: string | null;
  source_type: string;
  metadata: Record<string, unknown> | null;
};

export default function Sources() {
  const [rows, setRows] = useState<SourceRow[]>([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const { data, error: queryError } = await supabase
        .from("source_documents")
        .select("id,external_reference,project_name,title,file_name,source_type,metadata")
        .order("project_name", { ascending: true })
        .limit(200);

      if (cancelled) return;
      if (queryError) setError(queryError.message);
      else setRows((data ?? []) as SourceRow[]);
      setBusy(false);
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="stack-xl">
      <header className="page-header">
        <div>
          <p className="eyebrow">Proveniência</p>
          <h2>Fontes históricas importadas</h2>
          <p className="muted">
            Cada preço mantém ligação ao ficheiro e à proposta de onde foi extraído.
          </p>
        </div>
      </header>

      {busy ? <div className="empty card">A carregar fontes…</div> : null}
      {error ? <div className="alert alert-error">{error}</div> : null}

      {!busy && !error ? (
        <div className="table-card card">
          <div className="source-table source-table-head">
            <span>Proposta</span>
            <span>Obra / projeto</span>
            <span>Ficheiro</span>
            <span>Ano</span>
          </div>
          {rows.map((row) => {
            const year =
              row.metadata && typeof row.metadata["proposal_year"] !== "undefined"
                ? String(row.metadata["proposal_year"])
                : "—";

            return (
              <div className="source-table" key={row.id}>
                <span className="mono">{row.external_reference || "—"}</span>
                <span>{row.project_name || "—"}</span>
                <span className="muted">{row.file_name || row.title}</span>
                <span>{year}</span>
              </div>
            );
          })}
        </div>
      ) : null}
    </section>
  );
}
